module.exports = __webpack_public_path__ + "static/media/sync-img.5e8036a1.png";